"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("./VIcon.vue"));
exports.default = vue_1.default.extend({
    name: "v-alert",
    components: { VIcon: VIcon_vue_1.default },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        variant: {
            type: String,
            default: "success"
        },
        icon: {
            type: String
        },
        dismissible: {
            type: Boolean,
            default: false
        }
    }
});
